import React from "react";

const iconDropdownHolder = {
  closeIconDropdown(e) {
    if (iconDropdownHolder.containerRef && !iconDropdownHolder.containerRef.current?.contains(e.target)) {
      iconDropdownHolder.internalStateSetter('isOpen', false);
      document.removeEventListener("mousedown", iconDropdownHolder.closeIconDropdown)
    }
  }
};

export default {
  'IconDropdown.Wrapper.HeaderWrapper': async ({ isOpen, containerRef, inputRef, isReadonly }, _, internalStateSetter) => {
    if (isReadonly) return;
    if (isOpen) return;
    await internalStateSetter('isOpen', !isOpen);

    let newContainerRef = containerRef;
    let newInputRef = inputRef;

    if (!containerRef || !inputRef) {
      newContainerRef = React.createRef(null);
      newInputRef = React.createRef(null);
      await internalStateSetter({ containerRef: newContainerRef, inputRef: newInputRef });
    }

    iconDropdownHolder.internalStateSetter = internalStateSetter;
    iconDropdownHolder.containerRef = newContainerRef;

    newInputRef?.current?.children?.[0]?.children?.[0]?.focus?.()

    document.addEventListener("mousedown", iconDropdownHolder.closeIconDropdown);
  },
  'IconDropdown.Wrapper.HeaderWrapper.LeftSide.SearchWrapper.SearchInput': ({ value }, _, internalStateSetter) => {
    internalStateSetter({ searchVal: value })
  },
  'IconDropdown.Wrapper.DropdownWrapper.BorderWrapper.ListWrapper.ListWrapper.Icon': ({ icon }, outlet, internalStateSetter) => {
    internalStateSetter('isOpen', false);
    document.removeEventListener("mousedown", iconDropdownHolder.closeIconDropdown)
    outlet({ selectedIcon: icon.id })
  },
  'IconDropdown.Wrapper.DropdownWrapper.BorderWrapper.ListWrapper.ButtonWrapper.ButtonWrapper.Link': ({ }, _, internalStateSetter) => {
    internalStateSetter({ searchVal: '' });
  },
}